/**
 * Track event
 */
export const trackEvent = (category: string, action: string, name?: string, value?: number) => {
  if (window._paq) {
    const args = ['trackEvent', category, action, name, value].filter((param) => param !== undefined);
    window._paq.push(args);
  }
};
